import ChevronDown from "@/assets/ChevronDown.svg";
import PropTypes from "prop-types";
import { Dropdown, Nav } from "react-bootstrap";
import { getMainMenu } from "@/functions/getMainMenu";
import { useState } from "react";
import Link from "next/link";
import { ensureTrailingSlash } from "@/functions/ensureTrailingSlash";

export default function SiteHeaderNav({ className }) {
  const nav = getMainMenu();
  const [show, setShow] = useState(null);

  return (
    <Nav className={className}>
      {nav.map(({ title, children, url, new_tab }, k) =>
        children ? (
          <div
            className="dropdown"
            key={k}
            onMouseEnter={() => setShow(k)}
            onMouseOver={() => setShow(k)}
            onMouseLeave={() => setShow(null)}
            onMouseOut={() => setShow(null)}
          >
            <Nav.Item>
              <Nav.Link href={ensureTrailingSlash(url)} target={new_tab ? "_blank" : "_self"}>
                {title}
              </Nav.Link>
              <Dropdown.Toggle variant={false} aria-label={`${title} menu`}>
                <ChevronDown onClick={() => setShow(k)} />
              </Dropdown.Toggle>
            </Nav.Item>
            <Dropdown.Menu show={show === k}>
              {children.map(({ title, url, new_tab }, k) => (
                <Dropdown.Item as={Nav.Item} key={k} className="bg-tertiary hover-bg-quaternary text-white">
                  <Nav.Link
                    href={ensureTrailingSlash(url)}
                    target={new_tab ? "_blank" : "_self"}
                    onClick={() => setShow(null)}
                  >
                    {title}
                  </Nav.Link>
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </div>
        ) : (
          <Nav.Item key={k}>
            <Nav.Link href={ensureTrailingSlash(url)} target={new_tab ? "_blank" : "_self"}>
              {title}
            </Nav.Link>
          </Nav.Item>
        ),
      )}
      <div className="externalBtn">
        <div className="d-flex justify-content-center align-items-center text-center mb-4">
          <Link href={"https://mytempagency.bluearrow.co.uk/s/login"}>
            <button className="bg-primary text-white btn mx-2">Candidate</button>
          </Link>

          <Link href={"https://myportal.bluearrow.co.uk/s/login"}>
            <button className="text-white btn mx-2 btn-custom">Client</button>
          </Link>
        </div>
      </div>
    </Nav>
  );
}

SiteHeaderNav.defaultProps = {
  className: "",
};

SiteHeaderNav.propTypes = {
  className: PropTypes.string,
};
